import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" {...props}><path fill="currentColor" stroke="currentColor" d="M.14 14.44l7.2 7.94a.52.52 0 00.74 0L13.76 16l9-10.24 2.06-2.34c.45-.5-.29-1.24-.73-.74l-5.64 6.39-9 10.24-2.11 2.33h.74L.88 13.7c-.45-.5-1.19.24-.74.74z" /></svg>);